// components/Checkbox.jsx
import React from 'react';

export const Checkbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef(null);
  const resolvedRef = ref || defaultRef;

  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <input
      type="checkbox"
      className="checkbox"
      ref={resolvedRef}
      onClick={(e) => e.stopPropagation()}  
      {...rest}                             
    />
  );
});
